const styles = () => ({
  root: {
    position: 'relative',
  },
  trigger: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: '-10px',
    padding: '6px 10px',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: '13px',
    fontWeight: 500,
    color: '#002E47',
    '&:hover': {
      background: '#F4F6F8',
    },
  },
  triggerMeta: {
    flex: 'none',
    fontSize: '12px',
    fontWeight: 400,
    color: '#919EAB',
    whiteSpace: 'nowrap',
  },
  triggerIcon: {
    width: 14,
    height: 14,
    flex: 'none',
    color: '#919EAB',
  },
  menu: {
    position: 'absolute',
    top: 44,
    left: -10,
    zIndex: 20,
    width: 280,
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    padding: '6px',
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    boxShadow:
      '0 20px 40px -4px rgba(145,158,171,.24), 0 0 2px rgba(145,158,171,.2)',
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  menuLabel: {
    padding: '8px 10px 6px',
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '.06em',
    textTransform: 'uppercase',
    color: '#919EAB',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '100%',
    height: 44,
    padding: '0 8px',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    fontFamily: 'inherit',
    '&:hover': {
      background: '#F4F6F8',
    },
  },
  triggerAvatar: {
    width: 22,
    height: 22,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
    color: '#FFFFFF',
    fontSize: '10px',
    fontWeight: 700,
  },
  // A logo sits on white, whole (not cropped), inside the same square.
  avatarLogo: {
    overflow: 'hidden',
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
  optionAvatar: {
    width: 28,
    height: 28,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '7px',
    color: '#FFFFFF',
    fontSize: '11px',
    fontWeight: 700,
  },
  optionText: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.15,
  },
  optionName: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#002E47',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  optionMeta: {
    fontSize: '11px',
    color: '#919EAB',
  },
  optionCheck: {
    width: 16,
    height: 16,
    flex: 'none',
    color: '#015FFB',
  },
  divider: {
    height: 1,
    margin: '4px 6px',
    background: '#E5E7EB',
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '100%',
    height: 40,
    padding: '0 8px',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: '#015FFB',
    '&:hover': {
      background: '#F4F6F8',
    },
  },
  actionIcon: {
    width: 28,
    height: 28,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px dashed rgba(1,95,251,.5)',
    borderRadius: '7px',
    fontSize: '14px',
  },
})

export default styles
